import { Component, Input } from '@angular/core';
import { WagtailFullBleedSliderItemInterface } from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-full-bleed-slider-single',
    templateUrl: './single.component.html',
    styleUrls: ['./single.component.scss'],
    standalone: false
})
export class SingleComponent {

  @Input() slide?: WagtailFullBleedSliderItemInterface
  
}
